export default __webpack_public_path__ + "static/media/car.c888f227.jpg";